import { EmailSignatureService } from '@/services';
import Snackbar from '@/classes/snackbar';

const ERROR_SAVING_SIGNATURE = 'errors.savingEmailSignature';

export default {
  getOrganizationSignatures: async ({ commit, getters, dispatch }) => {
    try {
      const organizationId = getters.organizationId;
      const response = await EmailSignatureService.getOrganizationSignatures(organizationId);
      commit('setEmailSignatures', response);
    } catch (e) {
      if (e.response.status === 404) {
        dispatch('createEmailSignature', true);
      }
    }
  },
  createEmailSignature: ({ dispatch, getters }, isDefault = false) => {
    const organizationId = getters.organizationId;
    const emailSignature = {
      organizationId,
      name: 'New Signature',
      assignedEmails: [],
      isDefault,
      signature: '<p>Signature</p>',
      replySignature: '<p>Reply</p>',
      updatedBy: getters.username
    };

    dispatch('saveNewEmailSignature', emailSignature);
  },
  saveNewEmailSignature: async ({ commit }, emailSignature) => {
    const response = await EmailSignatureService.createEmailSignature(emailSignature);
    if (response) {
      commit('updateEmailSignature', response);
    }
  },
  updateEmailSignature: async ({ commit, dispatch, getters }, { field, value, setAsDefault }) => {
    const emailSignature = getters.selectedEmailSignature;
    emailSignature[field] = value;
    if (setAsDefault !== undefined) {
      emailSignature.isDefault = setAsDefault;
    }
    const response = await EmailSignatureService.updateEmailSignature(emailSignature).catch(() =>
      helpers.createErrorSavingSignature(dispatch)
    );
    if (response) {
      commit('updateEmailSignature', response);
    }
  },
  overwriteEmailSignature: async ({ dispatch, commit, getters }, emailSignature) => {
    const response = await EmailSignatureService.overwriteEmailSignature(
      getters.organizationId,
      emailSignature
    ).catch(() => helpers.createErrorSavingSignature(dispatch));
    if (response) {
      commit('setOverwriteEmailSignature', response);
    }
  },
  setSelectedEmailSignature: ({ commit }, id) => commit('setSelectedEmailSignature', id),
  overwriteDefaultSignature: async ({ dispatch, commit, getters }) => {
    const response = await EmailSignatureService.overwriteDefaultSignature(getters.organizationId).catch(() =>
      helpers.createErrorSavingSignature(dispatch)
    );
    if (response) {
      commit('setOverwriteEmailSignature', response);
    }
  }
};

const helpers = {
  createErrorSavingSignature: dispatch => {
    dispatch('createSnackbarMessage', {
      type: Snackbar.TYPE.ERROR,
      message: {
        i18nKey: ERROR_SAVING_SIGNATURE
      }
    });
  }
};
